"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RichText = /** @class */ (function (_super) {
    __extends(RichText, _super);
    function RichText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RichText.prototype.render = function () {
        return (React.createElement("span", { tabIndex: -1, "data-test-id": this.props.testId, dangerouslySetInnerHTML: { __html: this.validContent() } }));
    };
    RichText.prototype.validContent = function () {
        var temp = document.createElement('div');
        var decodeFlag = (this.props.data.isDecodingRequired !== undefined ?
            this.props.data.isDecodingRequired :
            true);
        var content = '';
        if (decodeFlag) {
            content = decodeURIComponent(this.props.data.text);
        }
        else {
            content = this.props.data.text;
        }
        temp.innerHTML = content;
        return this.isApprovedContent(Array.prototype.slice.call(temp.querySelectorAll('*')))
            ? content : 'INVALID';
    };
    RichText.prototype.isApprovedContent = function (elements) {
        // search for dis-allowed tags
        return elements.find(function (element) {
            var allowed = RichText.allowedTags[element.tagName];
            if (allowed) {
                if (Array.prototype.slice.call(element.attributes).find(function (attribute) { return allowed.indexOf(attribute.name) < 0; })) {
                    allowed = undefined; // found dis-allowed attribute
                }
            }
            return !allowed; // return true if dis-allowed element found
        }) === undefined;
    };
    RichText.allowedTags = {
        A: ['href', 'id', 'class', 'target'],
        B: [],
        BR: [],
        DIV: ['class', 'id'],
        I: [],
        LI: [],
        P: [],
        STRONG: [],
        SUB: ['class'],
        SUP: ['class'],
        U: [],
        UL: [],
    };
    return RichText;
}(React.Component));
exports.default = RichText;
//# sourceMappingURL=RichText.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/RichText/RichText.js
// module id = 1238
// module chunks = 8